import React from 'react';

const ListDisplay = () => (
  <div className="ListDisplay">
    This is the ListDisplay component.
  </div>
);

export default ListDisplay;



// WEBPACK FOOTER //
// ./src/containers/Main/ListDisplay.jsx